import { Component, Input, OnInit, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LoaderIndicatorDirective, LoaderService } from '@t-llevo/common-ui';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { VersionResponse } from 'admin-drivers/src/app/api/models/responses/VersionResponse';

@Component({
  selector: 't-llevo-summary-version-details',
  standalone: true,
  imports: [DatePipe, LoaderIndicatorDirective],
  providers: [LoaderService],
  template: `
    <div class="details" commonui-loader [appLoader]="loading() ?? false">
      <header>{{ versionTitle }}</header>
      <table>
        <tr>
          <td>Nombre de versión:</td>
          <td>{{ data?.versionName }}</td>
        </tr>
        <tr>
          <td>Código de versión:</td>
          <td>{{ data?.versionCode }}</td>
        </tr>
        <tr>
          <td>Fecha de actualización:</td>
          <td>{{ data?.updatedAt | date : 'dd/MM/yyyy - hh:mm a' }}</td>
        </tr>
        <tr>
          <td>Fecha de creación:</td>
          <td>{{ data?.createdAt | date : 'dd/MM/yyyy - hh:mm a' }}</td>
        </tr>
        <tr>
          <td>Nombre de paquete:</td>
          <td>{{ data?.packageName }}</td>
        </tr>
        <tr>
          <td>Enlace de descarga:</td>
          <td>
            @if(data?.urlDownload){
              <a 
                [href]="data?.urlDownload"
                target="_blank"
                class="downloadLink"
                [title]="data?.urlDownload"
              > 
                {{data?.urlDownload}} 
              </a>
            }
          </td>
        </tr>
      </table>
    </div>
  `,
  styles: `
    :host{
      position: relative;
    }

    .details {
      position: inherit;
      border-radius: 0.5rem;
      padding: 0.6rem 1rem;
      background: #FFF;
    }

    .details header {
      font-size: 1.5rem;
      padding: 0 0.2rem 0.5rem 0.2rem;
    }

    .details table {
      display: block;
      overflow: hidden;
    }

    .details table td {
      padding: 0.2rem;
      text-wrap: nowrap;
    }

    .details table td:last-child {
      font-weight: lighter;
    }

    .downloadLink{
      text-overflow: ellipsis;
      text-wrap: nowrap;
    }
  `
})
export class SummaryVersionDetailsComponent implements OnInit {
  @Input({ required: true }) dataObs!: Observable<VersionResponse | null>;
  @Input({ required: true }) versionTitle!: string;
  protected data: VersionResponse | null = null;

  private loaderSrv = inject(LoaderService);
  loading = toSignal(this.loaderSrv.loaderState$);

  ngOnInit(): void {
    this.loaderSrv.show();
    this.dataObs.subscribe((data) => {
      if (data) {
        this.data = data;
        this.loaderSrv.hide();
      }
    });
  }
}
